<template>

  <div>
    <a
      v-if="selectableProducts.length > 0"
      class="ml-16 text-sm text-green-500"
      href
      @click.prevent="addProductVisible = true"
    >
      + <span class="underline">Legg til produkt</span>
    </a>

    <portal to="modals">
      <div
        v-if="addProductVisible"
        class="fixed inset-0 z-50 flex items-center justify-center confirm"
      >
        <div class="p-8 bg-white rounded-md shadow-xl modal">
          <div class="mb-8 text-lg font-medium">Legg til produkt</div>
          <PLoader v-if="isLoading" />
          <template v-else>
            <div
              v-for="(product, index) in selectableProducts"
              :key="index"
              class="flex items-center w-full px-3 py-2 mt-1 mb-2 border border-gray-300 rounded-md bg-gradient-to-b from-gray-50 to-gray-200 "
            >
              <img
                :src="`${assetsBaseUrl}/media.ashx?${product.image}&template=product-image-69`"
                alt="Produktbilde"
              />

              <div class="ml-4">

                <div class="font-medium">
                  {{ product.productName }}
                </div>

                <div class="text-xs"> <!--  v-if="!isExternal && (isGL && product.isPooling) === false" -->
                  {{ product.qualityName }}
                  {{ product.treatmentIsDefault ? "" : product.treatmentName }}
                </div>

              </div>

              <div class="flex items-center justify-end flex-1">

                <div
                  v-if="product.isCommission"
                  class="ml-4 text-center"
                >
                  <div
                    class="font-medium"
                    v-html="$tk('Common.General.Commission')"
                  ></div>
                  <div
                    v-if="product.balance !== null"
                    :class="['text-sm', { 'text-green-500': product.balance > 0, 'text-red-500': product.balance < 0 }]"
                  >
                    <template v-if="product.balance > 0">
                      <span class="font-semibold">{{ product.balance }} </span>
                      <span v-html="$tk('Common.General.Credited').toLowerCase()"></span>
                    </template>
                    <template v-else-if="product.balance < 0">
                      <span class="font-semibold">{{ product.balance * -1 }} </span>
                      <span v-html="$tk('Common.General.Owes').toLowerCase()"></span>
                    </template>
                    <template v-else>
                      <span v-html="$tk('Common.General.Balance')"></span>:
                      <span class="font-semibold">{{ product.balance }}</span>
                    </template>
                  </div>
                </div>

                <PButton
                  class="ml-4"
                  @click="onAdd(product)"
                >
                  <PTranslation k="Common.Actions.Add" />
                </PButton>

                <!-- <div class="flex items-baseline text-lg" v-if="showPrices && product.price > 0">
                  <span class="text-xs">{{ product.currencyId }}</span>
                  <span class="ml-1 font-semibold">{{ numberFormat(product.price, 2) }}</span>
                </div> -->

              </div>
            </div>

          </template>

          <div class="flex justify-end mt-8 space-x-2">

            <PButton
              color="secondary"
              @click="addProductVisible = false"
            >
              <PTranslation k="Common.Actions.Cancel" />
            </PButton>

          </div>

        </div>
      </div>
    </portal>
  </div>
</template>

<script>

import http from "@/utilities/http"
import { mapGetters } from "vuex"
import {
  filter,
  every
} from "lodash"

export default {
  props: {
    order: {
      type: Object,
      required: true
    },
  },

  data() {
    return {
      products: [],
      locationTo: null,
      isLoading: false,
      addProductVisible: false
    }
  },

  computed: {
    ...mapGetters(["location"]),

    assetsBaseUrl() {
      return this.$appConfig.assetsBaseUrl
    },

    isGL() {
      return this.order.transactionTypeId === "GL"
    },

    selectableProducts() {
      return filter(this.products, p =>
        every(this.order.transactions, t =>
          p.productId !== t.productId &&
          p.qualityId !== t.qualityId &&
          p.treatmentId !== t.treatmentId
        )
      )
    }
  },
  methods: {
    onAdd(product) {
      this.addProductVisible = false
      this.$emit("add", product)
    },

    async init() {
      this.isLoading = true
      let locationTo;

      if (this.order.locationIdTo) {
        try {
          locationTo = await http.get("Location", {
            params: {
              id: this.order.locationIdTo
            }
          })
        } catch (error) {
          // eslint-disable-next-line
          console.error("Error init location", error)
        }
      }

      const params = {
        portalType: "PORTAL",
        transactionType: this.order.transactionType,
        truckTypeId: this.order.truckTypeId,
        orderId: this.order.id
      }
      let products = []
      if (this.isGL) {
        let poolingProducts = []
        let commissionProducts = []
        if (locationTo?.isPooling) {
          poolingProducts = await http.get("AvailableProducts", {
            params: {
              ...params,
              locationId: this.location.id,
              isPooling: true
            }
          })
        }
        if (locationTo?.isCommission) {
          commissionProducts = await http.get("AvailableProducts", {
            params: {
              ...params,
              locationId: locationTo.id,
              isCommission: true
            }
          })
        }

        products = poolingProducts.concat(commissionProducts)

      } else {

        products = await http.get("AvailableProducts", {
          params: {
            ...params,
            locationId: this.location.id
          }
        })
      }
      this.products = products
      this.isLoading = false
    },
  },
  watch: {
    order: {
      handler: function(val) {
        if (val) this.init()
      },
      deep: true,
      immediate: true
    }
  }

}
</script>

<style scoped>
.modal {
  width: 700px;
}
</style>